import type { Article, FeedCategory } from '@pff-consumer/schema'
import { useMemo } from 'react'
import { filter, includes } from 'lodash'
import { useGetFeedCategoriesQuery } from '../consumer-api'

// Converts a list of slugs to a list of full Feed Category objects that can be used downstream
export const useArticleFeedCategories = (params: {
  feedCategories: Article['feedCategories']
  client: string
  fromWordPress: boolean
}): FeedCategory[] => {
  const { data } = useGetFeedCategoriesQuery(params)

  return useMemo<FeedCategory[]>(() => {
    return filter(data, (d) => includes(params.feedCategories, d?.slug))
  }, [data, params.feedCategories])
}
